export const BankingFormField = {
    BankId: 'bankId',
    BankGroup: 'bankGroup',
    FullName: 'fullName',
    LogoUrl: 'logoUrl',
    RecipientsExist: 'recipients_exist'
} as const;

export const RecipientsPivotFormField = {
    BankId: 'bankId',
    Mor: 'MOR',
    RecipientId: 'recipientId',
    IsEnabled: 'isEnabled'
} as const;
